import { RestaurantVerticalCategory } from 'api/graphql';
import { Names } from 'types/icon';

const iconsRestaurantVerticalCategory: {
  [key in RestaurantVerticalCategory]: Names;
} = {
  bar: 'glass-martini-alt',
  chef: 'hat-chef',
  event: 'glass-cheers',
  service: 'utensils',
  wash: 'pump-soap',
  other: 'ellipsis',
};

const DEFAULT_YRKE_ICON: Names = 'ellipsis';

const getYrkeIcon = (code?: string | null): Names => {
  if (!code) {
    return DEFAULT_YRKE_ICON;
  }
  return (
    iconsRestaurantVerticalCategory[code as RestaurantVerticalCategory] ||
    DEFAULT_YRKE_ICON
  );
};

export const resource = {
  iconsRestaurantVerticalCategory,
  getYrkeIcon,
};
